import React, {useState, useEffect, useRef} from "react";
import queryString from "query-string";
import {
    LoginErrorText,
    ErrorText,
    Link,
    ResetTextStyle,
    LabelWrapper,
    LoginButton,
    LoginInput,
    Label,
    Field,
    InputWrapper,
} from "./styles/loginStyles";
import {ToggleCheckbox as Checkbox} from "BaseComponents/Checkbox";
import {ButtonText} from "BaseComponents/Button";
import {PageTransition} from "Animations";

const Login = ({
                   Forgot,
                   Login,
                   Password: PasswordText,
                   CookieDisclaimerText,
                   PasswordError,
                   Remember,
                   UserName,
                   UserNameError,
                   validate,
                   onChange,
                   toggleShowForgetPassword,
                   getHeaders,
                   CurrentPageId,
                   UseOpenID,
                   Providers
               }) => {
    const [emailError, setEmailError] = useState(false);
    const [passwordError, setPasswordError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [loginError, setLoginError] = useState(false);
    const [unauthorizedError, setUnauthorizedError] = useState(false);

    const emailRef = useRef(null);
    const passwordRef = useRef(null);

    const onSubmitClick = (e) => {
        e.preventDefault();
        setUnauthorizedError(false);

        let password = passwordRef.current;
        let email = emailRef.current;
        let isError = false;

        if (validate(password, "password")) {
            setPasswordError(true);
            isError = true;
        }
        if (validate(email, "email")) {
            setEmailError(true);
            isError = true;
        }

        if (!isError) {
            setIsLoading(true);
            let bodyJson = JSON.stringify({
                Username: email.value,
                Password: password.value,
                CurrentPageId
            });
            fetch(`/user/login`, {
                method: "POST",
                headers: getHeaders(),
                body: bodyJson,
            }).then(
                (resp) => {
                    if (resp.ok) {
                        const parsed = queryString.parse(location.search);
                        const {returnUrl} = parsed;
                        setIsLoading(false);
                        if (returnUrl != undefined && returnUrl.length) {
                            window.location.assign(returnUrl);
                        } else {
                            document.location.href = "/";
                        }
                    } else {
                        setIsLoading(false);
                        setUnauthorizedError(true);
                    }
                },
                (error) => {
                    setIsLoading(false);
                    setLoginError(true);
                }
            );
        }
    };

    return (
        <PageTransition transitionDuration="400" delay="100" wide>
            <InputWrapper>
                {!UseOpenID && <>
                    <Field>
                        <Label>{UserName}</Label>
                        <LoginInput
                            disabled={isLoading}
                            ref={emailRef}
                            type="email"
                            error={emailError}
                            aria-invalid={emailError}
                            onChange={(emailRef) =>
                                onChange(emailRef.currentTarget, "email", setEmailError)
                            }
                        />
                        {emailError && <ErrorText>{UserNameError}</ErrorText>}
                    </Field>
                    <Field>
                        <LabelWrapper>
                            <Label>{PasswordText}</Label>
                            <Link
                                onClick={(e) => {
                                    toggleShowForgetPassword(e);
                                }}
                            >
                                {Forgot}
                            </Link>
                        </LabelWrapper>
                        <LoginInput
                            disabled={isLoading}
                            ref={passwordRef}
                            type="password"
                            aria-invalid={passwordError}
                            error={passwordError}
                            onChange={(passwordRef) =>
                                onChange(passwordRef.currentTarget, "password", setPasswordError)
                            }
                        />
                        {
                            passwordError && <ErrorText>{PasswordError}</ErrorText>
                        }
                    </Field>
                </>
                }
                <ResetTextStyle>{CookieDisclaimerText}</ResetTextStyle>
                {/*{UseOpenID && <Link*/}
                {/*    onClick={(e) => {*/}
                {/*        toggleShowForgetPassword(e);*/}
                {/*    }}*/}
                {/*>*/}
                {/*    {Forgot}*/}
                {/*</Link>}*/}
                {UseOpenID && Providers?.length > 0 &&
                    Providers.map((c) => {
                        return (
                            <LoginButton
                                type="submit"
                                name="provider"
                                value={c}
                                key={c}
                                id={c}
                                width="100%"
                                pageloading={isLoading}
                                margin="3rem 0 0 0"
                            >
                                {!isLoading && (
                                    <ButtonText forcedFontSize="24px">{Login}</ButtonText>
                                )}
                            </LoginButton>
                        );
                    })}
                {!UseOpenID && <LoginButton
                    onClick={(e) => onSubmitClick(e)}
                    width="100%"
                    pageloading={isLoading}
                    margin="3rem 0 0 0"
                >
                    {!isLoading && <ButtonText forcedFontSize="24px">{Login}</ButtonText>}
                </LoginButton>}
                {loginError && (
                    <LoginErrorText>
                        Något gick fel vid inloggning, var god försök igen
                    </LoginErrorText>
                )}
                {unauthorizedError && (
                    <LoginErrorText>
                        Användarnamnet eller lösenordet är felaktigt, var god kontrollera
                        uppgifterna och försök igen.
                    </LoginErrorText>
                )}
            </InputWrapper>
        </PageTransition>
    );
};

export default Login;
